import { Sizes } from '../../constants/size';
import type { IconProps } from '../../types/icon-props';

export const TenantConcept = (props: IconProps) => {
  const { size = 'md', fill = 'var(--grey-1)', stroke = 'var(--grey-1)', ...rest } = props;

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={Sizes[size]}
      height={Sizes[size]}
      viewBox="0 0 239 124"
      fill="none"
      {...rest}
    >
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M119.082 91L189.4 0H238.082L167.764 91H119.082ZM119.082 33L49.896 124H0.0820312L69.2681 33H119.082Z"
        fill="#A5389C"
      />
    </svg>
  );
};

TenantConcept.displayName = 'TenantConcept';
